import { render, staticRenderFns } from "./MessageListCardSkeleton.vue?vue&type=template&id=7b07e3a2&scoped=true&"
import script from "./MessageListCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./MessageListCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./MessageListCardSkeleton.vue?vue&type=style&index=0&id=7b07e3a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b07e3a2",
  null
  
)

export default component.exports